import defaultImg from "@/assets/common/ListPreload.png";
import productDefault from "@/assets/common/preload.png";
import defaultIcon from "@/assets/selfSupport/marketResult.jpg";
export default {
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );

    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
  data() {
    return {
      subTab: "",
    };
  },
  methods: {
    adv1(router) {
      this.adv_url = router;
      let params = {
        adv_url: this.adv_url,
        shopId: this.shopId,
      };
      this.params(
        JSON.stringify(params),
        JSON.stringify(params),
        "adv_methodBS"
      );
    },
    advDefault() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    iconDefu() {
      var img = event.srcElement;
      img.src = defaultIcon;
      img.onerror = null; //防止闪图
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
    changeTab(l, s) {
      this.invokeStat("List_three_recommended-classification");
      this.isActive = s;
      this.area_id = l.id;
      this.sort_rule = l.sort_rule;
      this.page = 1;
      this.getGoodsList(true);
    },
    goBack() {
      this.params("", "", "goBack");
    },
    supportBS() {
      //分享
      this.params(this.shopId, this.shopId, "supportThreeYearBS");
    },
    goRulesPage() {
      this.$router.push({
        path: "/rules",
        query: {
          callback: true,
        },
      });
    },
    searchBS() {
      //搜索
      let params = {
        value: this.value,
        shopId: this.shopId,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "searchBS");
    },
    Router(router) {
      //轮播
      if (router) {
        this.invokeStat("List_three_banner1");
        let params = {
          route_url: router,
          shopId: this.shopId,
        };
        this.params(
          JSON.stringify(params),
          JSON.stringify(params),
          "goRouterBS"
        );
      }
    },
    noticeBS() {
      //公告
      this.params(this.shopId, this.shopId, "noticeBS");
    },
    handleScroll() {
      //页面滚动
      var scrolltop = document.querySelector(".supermarket-content").scrollTop;
      var offsetTop = 30;

      this.$nextTick(() => {
        let ListTop = document.querySelector("#subject-box").offsetTop;
        this.header = document.querySelector("#changeSearch").clientHeight;
        this.subTab = document.querySelector(".subject-tab").clientHeight;
        this.ishandBox = scrolltop + this.header > ListTop;
      });
      this.supermarketFixedTop = scrolltop > offsetTop ? true : false;
    },
    handleScroll1() {
      //分类滚动
      var scrollLeft = document.querySelector(".supermarket-swipeBox")
        .scrollLeft;
      this.insideSty.left =
        (scrollLeft / this.scrollBarW) *
          ((1 - 5 / Math.ceil(this.topCate.length / 2)) * 64) +
        "px";
    },
  },
};
